export const getPayment = (paymentMethod?: string) => {
    switch (paymentMethod) {
        case "I":
            return "Ideal";
        case "A":
            return "Factuur";
        default:
            break;
    }
}